import React from 'react';

import styled from '@emotion/styled';
import { Trans } from '@lingui/macro';

import { BREAKPOINTS, disabledColor, unit } from '@zego/theme';

import H2 from '@zego/components/atoms/H2';
import RegularText from '@zego/components/atoms/RegularText';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import ContentContainer from '@zego/components/ContentContainer';
import SectionDisplay from '@zego/components/SectionDisplay';
import SmallHeaderText from '@zego/components/SmallHeaderText';

import One from '@zego/static/svgs/One.svg';
import Three from '@zego/static/svgs/Three.svg';
import Two from '@zego/static/svgs/Two.svg';

const Icon = styled('img')({
  width: 90,
  height: 90,
  margin: '0 auto',
  display: 'block',
});

const HeaderText = styled(SmallHeaderText)({
  textAlign: 'center',
});

const HomeHowItWorks = () => (
  <View css={{ backgroundColor: disabledColor(2) }}>
    <SectionDisplay>
      <ContentContainer>
        <H2 css={{ textAlign: 'center' }}>
          <Trans id="HomepageHowItWorks.Heading">How it works</Trans>
        </H2>
        <Spacer height={unit(8)} />
        <View
          css={{
            [BREAKPOINTS.medium]: {
              display: 'flex',
              flexDirection: 'row',
            },
          }}
        >
          <View
            css={{
              marginBottom: 72,
              [BREAKPOINTS.medium]: {
                flex: 1,
                marginRight: 85,
                marginBottom: 0,
              },
            }}
          >
            <Icon src={One} alt="Step 1" />
            <Spacer height={45} />
            <HeaderText>
              <Trans id="HomepageHowItWorks.Step 1 Heading">
                Select your insurance
              </Trans>
            </HeaderText>
            <Spacer height={11} />
            <RegularText css={{ textAlign: 'center' }}>
              <Trans id="HomepageHowItWorks.Step 1 Description">
                We offer a range of flexible motor, professional and commercial
                insurance options. Choose the one that’s right for you to get
                started.
              </Trans>
            </RegularText>
          </View>
          <View
            css={{
              marginBottom: 72,
              [BREAKPOINTS.medium]: {
                flex: 1,
                marginRight: 85,
                marginBottom: 0,
              },
            }}
          >
            <Icon src={Two} alt="Step 2" />
            <Spacer height={45} />
            <HeaderText>
              <Trans id="HomepageHowItWorks.Step 2 Heading">Get a quote</Trans>
            </HeaderText>
            <Spacer height={11} />
            <RegularText css={{ textAlign: 'center' }}>
              <Trans id="HomepageHowItWorks.Step 2 Description">
                You can get a quote online or via the Zego app in minutes. Find
                us on the App Store and Google Play.
              </Trans>
            </RegularText>
          </View>
          <View
            css={{
              marginBottom: 72,
              [BREAKPOINTS.medium]: { flex: 1 },
            }}
          >
            <Icon src={Three} alt="Step 3" />
            <Spacer height={45} />
            <HeaderText>
              <Trans id="HomepageHowItWorks.Step 3 Heading">
                You’re all set!
              </Trans>
            </HeaderText>
            <Spacer height={11} />
            <RegularText css={{ textAlign: 'center' }}>
              <Trans id="HomepageHowItWorks.Step 3 Description">
                Once you accept your quote, all you have to do is link your
                account to your work provider and you’re ready to go!
              </Trans>
            </RegularText>
          </View>
        </View>
      </ContentContainer>
    </SectionDisplay>
  </View>
);

export default HomeHowItWorks;
